// extracted by mini-css-extract-plugin
export default {"edit-modal":"PromptModal_edit-modal__zGkpP"};